import { render, staticRenderFns } from "./HelpCenterBanner.vue?vue&type=template&id=2d2dcb6d"
import script from "./HelpCenterBanner.vue?vue&type=script&lang=js"
export * from "./HelpCenterBanner.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterBanner.vue?vue&type=style&index=0&id=2d2dcb6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports